import { render, staticRenderFns } from "./AdministrationLayout.vue?vue&type=template&id=c09ca0ec"
import script from "./AdministrationLayout.vue?vue&type=script&lang=ts"
export * from "./AdministrationLayout.vue?vue&type=script&lang=ts"
import style0 from "./AdministrationLayout.vue?vue&type=style&index=0&id=c09ca0ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports